import Vue from 'vue'
import VueRouter from 'vue-router'
// import { MessageBox } from 'element-ui';

Vue.use(VueRouter)
// let ct = new Vue

const routes = [
  {
    path: '/',
    name: 'Home-index',
    meta: {
      title: '首页'
    },
    component: () => import('@/views/homePage/home.vue')
  },
  {
    path: '/logIn',
    name: "logIn",
    component: () => import('@/views/login.vue'),
    meta: {
      title: '登录'
    },
    query: {
      password: "1", // 默认密码登录
      sort: 'desc'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },

  {
    path: '/recharge',
    name: 'recharge-index',
    component: () => import('@/views/homePage/recharge.vue')
  },
  {
    path: '/rechargeS',
    name: 'rechargeS-index',
    component: () => import('@/views/homePage/rechargeS.vue')
  },
  {
    path: '/advancedSearch',
    name: 'advancedSearch',
    component: () => import('@/views/homePage/advancedSearch.vue')
  },
  {
    path: '/SearchDetails',
    name: 'SearchDetails',
    component: () => import('@/views/homePage/SearchDetails.vue')
  },
  {
    path: '/chatGpt',
    name: 'chatGpt',
    component: () => import('@/views/homePage/chatGpt.vue')
  },
  {
    path: '/industrialService',
    name: 'industrialService',
    // meta: { requiresAuth: true },
    component: () => import('@/views/homePage/industrialService.vue')
  },
  {
    path: '/zhaoshang',
    name: 'zhaoshang',
    component: () => import('@/views/homePage/zhaoshang.vue')
  },
  {
    path: '/VIP',
    name: 'VIP',
    component: () => import('@/views/homePage/VIP.vue')
  },
  {
    path: '/personalCenter',
    name: 'personalCenter',
    component: () => import('@/views/homePage/personalCenter.vue')
  },
  {
    path: '/yuanQu',
    name: 'yuanQu',
    meta: { requiresAuth: true },
    component: () => import('@/views/homePage/yuanqu.vue')
  },
  {
    path: '/shuziYuanqu',
    name: 'shuziYuanqu',
    component: () => import('@/views/homePage/shuziyuanqu.vue')
  },
  {
    path: '/woyaocanYu',
    name: 'woyaocanYu',
    meta: { requiresAuth: true },
    component: () => import('@/views/gongxu/woyaocanyu.vue')
  },
  {
    path: '/VIPEquities',
    name: 'VIPEquities',
    component: () => import('@/views/VIP/VIPEquities.vue')
  },
  {
    path: '/organization',
    name: 'organizationVue',
    component: () => import('@/views/VIP/organization.vue')
  },
  {
    path: '/openVIP',
    name: 'openVIP',
    component: () => import('@/views/VIP/openVIP.vue')
  },
  {
    path: '/historyName',
    name: 'historyName',
    component: () => import('@/views/personage/historyName.vue')
  },
  {
    path: '/invoiceSet',
    name: 'invoiceSet',
    component: () => import('@/views/personage/invoiceSet.vue')
  },
  {
    path: '/nameAttention',
    name: 'nameAttention',
    component: () => import('@/views/personage/nameAttention.vue')
  },
  {
    path: '/orderForm',
    name: 'orderForm',
    component: () => import('@/views/personage/orderForm.vue')
  },
  {
    path: '/404',
    name: '404C',
    component: () => import('../views/404.vue')
  },
  {
    path: '/passwordSet',
    name: 'passwordSet',
    component: () => import('@/views/personage/passwordSet.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('@/views/personage/contactUs.vue')
  },
  {
    path: '/complaint',
    name: 'complaint',
    component: () => import('@/views/personage/complaint.vue')
  },
  {
    path: '/applyFor',
    name: 'applyFor',
    component: () => import('@/views/personage/applyFor.vue')
  },
  {
    path: '/agreement',
    name: 'agreementV',
    component: () => import('@/views/agreement.vue')
  },
  {
    path: '/chatGptS',
    name: 'chatGptS',
    meta: { requiresAuth: true },
    component: () => import('../views/chatGpt.vue')
  },
  {
    path: '/publishPage',
    name: 'publishPage',
    component: () => import('../views/personage/publishPage.vue')
  },
  {
    path: '/miPublishPage',
    name: 'miPublishPage',
    component: () => import('../views/personage/miPublishPage.vue')
  }


]


// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const ct = new Vue

router.beforeEach((to,from,next)=>{

  if (to.matched.some(record => record.meta.requiresAuth)) {
    let userId = ct.decryptAesString(localStorage.getItem("name"))

    if(userId.userInfo.vip==0){
      ct.$message({
        message: '请先开通会员',
        type: 'warning'
      });
      next("/VIP")
    }else{
      next()
    }
  }else {
    next()
  }

  // const token = localStorage.getItem('token');
  // const whiteList = ['/logIn', '/404']; 

  // if (whiteList.includes(to.path)) {
  //   next();
  //   return;
  // }
  // if (token) {
  //   next();
  //   return;
  // }

  // // 用 Element UI 的确认弹框
  // MessageBox.confirm(
  //   '未检测到登录状态，前往登录页还是返回首页？',
  //   '提示',
  //   {
  //     confirmButtonText: '去登录页',
  //     cancelButtonText: '回首页',
  //     type: 'warning'
  //   }
  // )
  // .then(() => {
  //   // 点“确定” → 登录页
  //   next('/logIn');
  // })
  // .catch(() => {
  //   // 点“取消” → 首页
  //   next('/');
  // });
})


// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token');
//   const whiteList = ['/logIn', '/404']; 

//   if (whiteList.includes(to.path)) {
//     next();
//     return;
//   }
//   if (token) {
//     next();
//     return;
//   }

//   // 用 Element UI 的确认弹框
//   MessageBox.confirm(
//     '未检测到登录状态，前往登录页还是返回首页？',
//     '提示',
//     {
//       confirmButtonText: '去登录页',
//       cancelButtonText: '回首页',
//       type: 'warning'
//     }
//   )
//   .then(() => {
//     // 点“确定” → 登录页
//     next('/logIn');
//   })
//   .catch(() => {
//     // 点“取消” → 首页
//     next('/');
//   });
// });

// const ct = new Vue
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token'); // 从 localStorage 获取 token
//   let st = null
//   if (localStorage.getItem("name")) {
//     st = ct.decryptAesString(localStorage.getItem("name"));//是否充值

//   } else {
//     st = null
//   }
//   if (to.meta.title) {

//     if (to.meta.title == "首页") {
//       console.log(151515165);
//       next()
//     } else if (to.meta.title == "登录"){
//       if (token) {
//         console.log("object");
//         next('/')
//       }else{
//         console.log(515165);
//         next()
//       }
//     }else if(to.meta.title == "修改密码"){
//       next()
//     }
//   } else {
//     if (token) {
//       if (to.path == "/recharge") {
//         if (st.userInfo) {
//           if (st.userInfo.vip == 0) {
//             next()
//           } else {
//             next('/rechargeS')
//           }
//         } else {
//           if (st.vip == 0) {
//             next()
//           } else {
//             next('/rechargeS')
//           }
//         }
//       }else {
//         next()
//       }
//     } else {
//       console.log("d2w69a+f1");
//       next('/logIn')
//     }

//   }
// })

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token'); // 从 localStorage 获取 token
//   let st = null
//   if (localStorage.getItem("name")) {
//     st = ct.decryptAesString(localStorage.getItem("name"));//是否充值

//   } else {
//     st = null
//   }
//   // 如果访问的页面需要身份验证


//   if (to.path == '/') {
//     if (token) {
//       next('/index')
//     }
//     next()
//   } else if (to.path !== '/login' && !token) {
//     next({ path: '/' }); // 如果没有 token
//   } else {
//     // if(to.path=="/recharge"&& st.userInfo.vip == 0){
//     //   next()
//     // }else {
//     //   next("/rechargeS")
//     // }
//     if (to.path == "/recharge") {
//       console.log("www");
//       if (st.userInfo) {
//         if (st.userInfo.vip == 0) {
//           next()
//         } else {
//           next('/rechargeS')
//         }
//       } else {
//         if (st.vip == 0) {
//           next()
//         } else {
//           next('/rechargeS')
//         }
//       }

//     }
//     next(); // 继续导航
//   }
// });

export default router
